import { Teacher } from '../../../../interfaces/examiner/Teacher';

export interface SchoolGroup {
  name: string;
  teacherCount: number;
  teachers: Teacher[];
}

export type ListSelectionFilter = 'all' | 'unselected' | 'selected';

export function getListSelectionFilterOptions(
  entityLabel: string
): { value: ListSelectionFilter; label: string }[] {
  return [
    { value: 'all', label: `All ${entityLabel}` },
    { value: 'unselected', label: 'Show only unselected' },
    { value: 'selected', label: 'Show only selected' },
  ];
}

export type TeacherLocationFilter = 'all' | Teacher['location'];

export interface Selection {
  type: 'exam' | 'school' | 'teacher';
  id: string;
  label: string;
  count?: number;
  /** Exams this teacher was selected through (exam tab). */
  examIds?: string[];
  /** Schools this teacher was selected through (schools tab). */
  schoolIds?: string[];
  /** Selected directly on the Teachers tab. */
  manual?: boolean;
}

export interface FailedRecipient {
  email: string;
  name: string;
  subject: string;
}

export interface SentRecipient {
  email: string;
  name: string;
  subject: string;
}

export interface SendResult {
  sent: number;
  failed: number;
  total: number;
  sentRecipients?: SentRecipient[];
  failedRecipients?: FailedRecipient[];
}

export interface RecipientRow {
  teacherId: string;
  teacherName: string;
  school: string;
  examTitles: string[];
  email: string;
}
